import { render } from "./Matriculas.vue?vue&type=template&id=7a8e9fc6"
import script from "./Matriculas.vue?vue&type=script&lang=js"
export * from "./Matriculas.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__